export default __webpack_public_path__ + "static/media/check-in.cbbc8c84.jpg";